import LoadingSpinner from '../../../../../common/_custom/LoadingSpinner/LoadingSpinner';
import { INGESTION_NOTE_MESSAGE } from './constants';
import styles from './FinancialsIngestionNote.module.scss';

/**
 * The ingestion-in-progress note (RECUR-28096, design D1-D3): a purple spinner matching the
 * Financial Ratios button colour, followed by a static grey label. Replaces
 * "(No data available)" on an empty section, or follows the unit suffix on a populated one —
 * see AuditedStatementSection / ProvisionalOtherMisSection for the placement logic.
 */
const FinancialsIngestionNote = () => (
    <span className={styles.Wrapper}>
        <LoadingSpinner color="var(--primary-text-colour)" height="14px" />
        <span className={styles.Label}>{INGESTION_NOTE_MESSAGE}</span>
    </span>
);

export default FinancialsIngestionNote;
